import { bindSearchInput, debounce } from './search-input';
import { highlightCardText, normalizeQuery } from './search-highlight';

const HIDDEN_CLASS = 'is-hidden-by-search';
const ANALYTICS_DEBOUNCE_MS = 300;
const CARD_TEXT_SELECTORS = 'a.title, .title';

function collectSearchableText(card) {
  const parts = [];
  const nodes = card.querySelectorAll(CARD_TEXT_SELECTORS);

  for (let i = 0; i < nodes.length; i += 1) {
    parts.push(nodes[i].textContent || '');
  }

  return parts.join(' ').toLowerCase();
}

function countVisibleCards(cards) {
  let visible = 0;
  for (let i = 0; i < cards.length; i += 1) {
    if (!cards[i].classList.contains(HIDDEN_CLASS)) {
      visible += 1;
    }
  }
  return visible;
}

function setEmptyVisible(empty, visible) {
  if (!empty) {
    return;
  }

  empty.hidden = !visible;
  empty.style.display = visible ? '' : 'none';
}

function trackCatalogSearch(term) {
  if (window.HSTracking && typeof window.HSTracking.track === 'function') {
    window.HSTracking.track('shop:catalog_search', {
      search_term: String(term || '').toLowerCase(),
    });
  }
}

function initCatalogSearch(container) {
  const inputSelector = container.getAttribute('data-hs-catalog-input') || "input[name='search']";
  const cardSelector = container.getAttribute('data-hs-catalog-card') || '.item.card';
  const emptySelector = container.getAttribute('data-hs-catalog-empty') || '.no-result-search';
  const input = container.querySelector(inputSelector);

  if (!input) {
    return;
  }

  const cards = container.querySelectorAll(cardSelector);
  const empty = container.querySelector(emptySelector);
  const track = debounce(function onTrack() {
    trackCatalogSearch(normalizeQuery(input.value));
  }, ANALYTICS_DEBOUNCE_MS);

  function applyFilter(rawQuery) {
    const query = normalizeQuery(rawQuery).toLowerCase();

    for (let i = 0; i < cards.length; i += 1) {
      const card = cards[i];
      const matches = !query || collectSearchableText(card).indexOf(query) > -1;
      card.classList.toggle(HIDDEN_CLASS, !matches);

      if (matches && query) {
        highlightCardText(card, query, CARD_TEXT_SELECTORS);
      } else {
        highlightCardText(card, '', CARD_TEXT_SELECTORS);
      }
    }

    setEmptyVisible(empty, query.length > 0 && countVisibleCards(cards) === 0);
    track();
  }

  bindSearchInput(input, applyFilter);
}

function initAll() {
  const containers = document.querySelectorAll('[data-hs-catalog-search]');
  for (let i = 0; i < containers.length; i += 1) {
    initCatalogSearch(containers[i]);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
